import { render, staticRenderFns } from "./PersonalWishes.vue?vue&type=template&id=2348f900&scoped=true&"
import script from "./PersonalWishes.vue?vue&type=script&lang=js&"
export * from "./PersonalWishes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2348f900",
  null
  
)

export default component.exports